if (!customElements.get('blog-posts')) {
  class BlogPosts extends HTMLElement {
    constructor() {
      super();
    }
    

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.blog-posts__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        scrollbar: '.swiper-scrollbar',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.sliderInstance = false;
      this.init();
    }

    init() {
      if (this.classList.contains('swiper')) {
        this.initSlider();
      }
    }

    initSlider() {
      const gapDesktop = parseInt(this.dataset.gapDesktop) || 30;
      const gapMobile = parseInt(this.dataset.gapMobile) || 16;
      const columnsMobile = this.dataset.columnsMobile || '1';
      
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Scrollbar].filter(m => typeof m === 'function'),
        slidesPerView: columnsMobile === '1' ? 1 : 'auto',
        spaceBetween: gapMobile,
        centeredSlides: columnsMobile !== '1',
        roundLengths: true,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        scrollbar: {
          el: this.querySelector(this.selectors.scrollbar),
          draggable: true,
        },
        pagination: false,
        loop: false,
        threshold: 2,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: parseInt(this.dataset.columnsDesktop) || 4,
            spaceBetween: gapDesktop,
            centeredSlides: false,
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            if (this.sliderInstance.slider) {
              this.sliderInstance.slider.slideTo(index);
            }
          });
        }
      }
    }

    destroySlider() {
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('blog-posts', BlogPosts);
}
